<template>
  <section id="disposition_sync_admin">
    <h1 class="title" tabindex="-1">Statut de mes candidatures</h1>

    <div class="on-off-radio-buttons-container">
      <div class="labels">
        <label class="strong">
          J’accepte que le statut de mes candidatures soit transmis aux jobboards
        </label>
      </div>

      <div class="radio-buttons">
        <span class="radio-button">
          <input
            type="radio"
            v-model="isSendApplicationStatusEnabled"
            :value="true"
            @change="setIsSendApplicationStatusEnabled(true)"
          >
          <label>Accepter tout</label>
        </span>
        <span class="radio-button">
          <input
            type="radio"
            v-model="isSendApplicationStatusEnabled"
            :value="false"
            @change="setIsSendApplicationStatusEnabled(false)"
          >
          <label>Refuser tout</label>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DispositionSyncAdmin',

  data () {
    return {
      isSendApplicationStatusEnabled: Boolean
    }
  },

  computed: {
    ...mapGetters([
      'tamConfiguration'
    ])
  },

  watch: {
    tamConfiguration () {
      this.initRadioButtons()
    }
  },

  mounted () {
    this.initRadioButtons()
  },

  methods: {
    ...mapActions([
      'setSendApplicationStatusSetting'
    ]),

    initRadioButtons () {
      this.isSendApplicationStatusEnabled = this.tamConfiguration.IsSendApplicationStatusEnabled
    },

    setIsSendApplicationStatusEnabled (value) {
      this.setSendApplicationStatusSetting(value)
    }
  }
}
</script>
